import React from "react";

import "./SearchInput.css";

const SearchInput = ({ onChange, value, placeholder }) => {
  return (
    <div className="search-group">
      <div className="search-icon">
        <img src="/images/search.svg" alt="search" />
      </div>
      <input
        type="search"
        placeholder={placeholder !== undefined ? placeholder : "Search Product..."}
        onChange={onChange}
        value={value}
      />
    </div>
  );
};

export default SearchInput;
